import {
  createAccountId,
  createFirmId,
  createLawyerId,
  createProductId,
} from '@domain/value-objects';
import type { Unbrand } from '@shared/value-objects/brand';
import { optVO, reqRecord, reqVO, voArray } from '@shared/value-objects/parse-helpers';
import { createISODate, createMoneyAmount } from '@shared/value-objects';
import type { Opportunity } from './model';

/// API の生レスポンス (`unknown`) を検証して branded な `Opportunity` にする門番 (parse, don't validate / #471)。
/// 失敗方針: 必須 id・present かつ不正な任意フィールドは throw、任意の値なしは null、`raw` 値はログに載せない。

export function parseOpportunity(raw: unknown): Opportunity {
  reqRecord(raw, 'opportunity');
  const dto = raw as Unbrand<Opportunity>;
  return {
    ...dto,
    firm_id: reqVO(dto.firm_id, createFirmId, 'opportunity.firm_id'),
    primary_lawyer_id: optVO(dto.primary_lawyer_id, createLawyerId, 'opportunity.primary_lawyer_id'),
    related_lawyer_ids: voArray(
      dto.related_lawyer_ids,
      createLawyerId,
      'opportunity.related_lawyer_ids',
    ),
    main_interest_lawyer_id: optVO(
      dto.main_interest_lawyer_id,
      createLawyerId,
      'opportunity.main_interest_lawyer_id',
    ),
    proposed_product_ids: voArray(
      dto.proposed_product_ids,
      createProductId,
      'opportunity.proposed_product_ids',
    ),
    assignee_account_ids: voArray(
      dto.assignee_account_ids,
      createAccountId,
      'opportunity.assignee_account_ids',
    ),
    expected_monthly_amount: optVO(
      dto.expected_monthly_amount,
      createMoneyAmount,
      'opportunity.expected_monthly_amount',
    ),
    expected_initial_amount: optVO(
      dto.expected_initial_amount,
      createMoneyAmount,
      'opportunity.expected_initial_amount',
    ),
    confirmed_monthly_amount: optVO(
      dto.confirmed_monthly_amount,
      createMoneyAmount,
      'opportunity.confirmed_monthly_amount',
    ),
    started_on: optVO(dto.started_on, createISODate, 'opportunity.started_on'),
    expected_close_on: optVO(dto.expected_close_on, createISODate, 'opportunity.expected_close_on'),
    closed_on: optVO(dto.closed_on, createISODate, 'opportunity.closed_on'),
    desired_start_date: optVO(
      dto.desired_start_date,
      createISODate,
      'opportunity.desired_start_date',
    ),
  };
}
